import React from 'react';
import { useLazyRef } from '@shopify/react-hooks';
import { useServerEffect } from '@shopify/react-effect';
import { HydrationContext } from './context.mjs';
import { HYDRATION_ATTRIBUTE } from './shared.mjs';

const Hydrator = /*#__PURE__*/React.memo(function Hydrator({
  children,
  id
}) {
  const manager = React.useContext(HydrationContext);
  const hydrationId = useLazyRef(() => manager.hydrationId(id)).current;
  const hydrationProps = {
    [HYDRATION_ATTRIBUTE]: hydrationId
  };
  useServerEffect(() => {}, manager.effect);
  return children ? /*#__PURE__*/React.createElement("div", hydrationProps, children) : /*#__PURE__*/React.createElement("div", Object.assign({}, hydrationProps, {
    dangerouslySetInnerHTML: {
      __html: manager.getHydration(hydrationId) || ''
    }
  }));
});

export { Hydrator };
